export default "__VITE_ASSET__fDWUEoWO__"